/** Route meta: permission = { module, action } for access guard; sadminOnly = true for super-admin-only routes */
const SAdminRoutes = [
  {
    path: "/admin/organizations",
    name: "AdminOrganizations",
    component: () => import("../views/admin/Organizations/AdminOrganizations.vue"),
    meta: { sadminOnly: true },
  },
  {
    path: "/admin/organizations/:id/admins",
    name: "AdminOrganizationAdmins",
    component: () => import("../views/admin/Organizations/AdminOrganizationAdmins.vue"),
    meta: { sadminOnly: true },
  },
  {
    path: "/admin/analytics",
    name: "AdminAnalytics",
    component: () => import("../views/admin/AdminAnalytics.vue"),
    meta: { permission: { module: "Dashboard", action: "read" } },
  },
  {
    path: "/admin/rooms",
    name: "AdminRooms",
    component: () => import("../views/admin/Configurations/AdminRooms.vue"),
    meta: { permission: { module: "Rooms", action: "read" } },
  },
  {
    path: "/admin/tenants/all",
    name: "AdminTenants",
    component: () => import("../views/admin/Tenants/AdminTenants.vue"),
    meta: { permission: { module: "Tenants", action: "read" } },
  },
  {
    path: "/admin/tenants/archived",
    name: "AdminArchivedTenants",
    component: () => import("../views/admin/Tenants/AdminArchivedTenants.vue"),
    meta: { permission: { module: "Tenants", action: "read" } },
  },
  {
    path: "/admin/tenants/add",
    name: "AdminAddTenants",
    component: () => import("../views/admin/Tenants/AdminAddTenants.vue"),
    meta: { permission: { module: "Tenants", actions: ["add", "edit"] } },
  },
  {
    path: "/admin/tenants/import",
    name: "TenantImport",
    component: () => import("../views/admin/Tenants/TenantImport.vue"),
    meta: { permission: { module: "Tenants", action: "add" } },
  },
  {
    path: "/admin/tenants/all/view/:id",
    name: "AdminViewTenant",
    component: () => import("../views/admin/Tenants/AdminViewTenant.vue"),
    meta: { permission: { module: "Tenants", action: "read" } },
  },
  {
    path: "/admin/employees/all",
    name: "AdminEmployees",
    component: () => import("../views/admin/Employees/AdminEmployees.vue"),
    meta: { permission: { module: "Employees", action: "read" } },
  },
  {
    path: "/admin/employees/add",
    name: "AdminAddEmployee",
    component: () => import("../views/admin/Employees/AdminAddEmployee.vue"),
    meta: { permission: { module: "Employees", actions: ["add", "edit"] } },
  },
  {
    path: "/admin/employees/roles",
    name: "AdminRoles",
    component: () => import("../views/admin/Employees/AdminRoles.vue"),
    meta: { permission: { module: "Employee Roles", action: "read" } },
  },
  {
    path: "/admin/employees/roles/add",
    name: "AdminAddRole",
    component: () => import("../views/admin/Employees/AdminAddRole.vue"),
    meta: { permission: { module: "Employee Roles", actions: ["add", "edit"] } },
  },
  {
    path: "/admin/invoices",
    name: "AdminPayments",
    component: () => import("../views/admin/Payments/AdminPayments.vue"),
    meta: { permission: { module: "Invoices", action: "read" } },
  },
  {
    path: "/admin/invoices/view/:billId",
    name: "AdminViewInvoice",
    component: () => import("../views/admin/Payments/AdminViewInvoice.vue"),
    meta: { permission: { module: "Invoices", action: "read" } },
  },
  {
    path: "/admin/subscriptions",
    name: "AdminSubscriptionsList",
    component: () => import("../views/admin/Subscriptions/AdminSubscriptionsList.vue"),
    meta: { permission: { module: "Subscriptions", action: "read" } },
  },
  {
    path: "/admin/subscriptions/payment-lines",
    name: "AdminPaymentLines",
    component: () => import("../views/admin/Subscriptions/AdminPaymentLines.vue"),
    meta: { permission: { module: "Payment Lines", action: "read" } },
  },
  {
    path: "/admin/subscriptions/past-clients",
    name: "AdminPastClients",
    component: () => import("../views/admin/Subscriptions/AdminPastClients.vue"),
    meta: { permission: { module: "Subscriptions", action: "read" } },
  },
  {
    path: "/admin/requests/booking-requests",
    name: "AdminBookingRequests",
    component: () => import("../views/admin/Requests/AdminBookingRequests.vue"),
    meta: { permission: { module: "Booking Requests", action: "read" } },
  },
  {
    path: "/admin/requests/cancellation-requests",
    name: "AdminCancellationRequests",
    component: () => import("../views/admin/Requests/AdminCancellationRequests.vue"),
    meta: {
      permission: { module: "Subscription Cancellation", action: "read" },
    },
  },
  {
    path: "/admin/requests/action-requests",
    name: "AdminActionRequests",
    component: () => import("../views/admin/Requests/AdminActionRequests.vue"),
    meta: { permission: { module: "Action Requests", action: "read" } },
  },
  {
    path: "/admin/configurations/floors",
    name: "AdminFloors",
    component: () => import("../views/admin/Configurations/AdminFloors.vue"),
    meta: { permission: { module: "Floors", action: "read" } },
  },
  {
    path: "/admin/configurations/wings",
    name: "AdminWings",
    component: () => import("../views/admin/Configurations/AdminWings.vue"),
    meta: { permission: { module: "Wings", action: "read" } },
  },
  {
    path: "/admin/configurations/room-classes",
    name: "AdminRoomClasses",
    component: () => import("../views/admin/Configurations/AdminRoomClasses.vue"),
    meta: { permission: { module: "Room Classes", action: "read" } },
  },
  {
    path: "/admin/complaints/board",
    name: "AdminComplaints",
    component: () => import("../views/admin/Complaints/AdminComplaints.vue"),
    meta: { permission: { module: "Complaints", action: "read" } },
  },
  {
    path: "/admin/messages",
    name: "AdminMessages",
    component: () => import("../views/admin/Messages/AdminMessages.vue"),
    meta: { permission: { module: "Messages", action: "read" } },
  },
  {
    path: "/admin/communications",
    name: "AdminCommunications",
    component: () => import("../views/admin/Communications/AdminCommunications.vue"),
    meta: { permission: { module: "Communications", action: "read" } },
  },
  {
    // :id is "new" for a fresh draft, else a campaign_id (draft → edit, sent → report)
    path: "/admin/communications/:id",
    name: "AdminCampaign",
    component: () => import("../views/admin/Communications/AdminCampaignEditor.vue"),
    meta: { permission: { module: "Communications", action: "read" } },
  },
  {
    path: "/admin/activities",
    name: "AdminActivities",
    component: () => import("../views/admin/Activities/AdminActivities.vue"),
    // No meta.permission: every signed-in admin can reach this page. The
    // component switches to personal mode when the caller lacks Activities:read,
    // showing only their own activity via /history/getMyHistory.
  },
  {
    path: "/admin/posts",
    name: "AdminPosts",
    component: () => import("../views/admin/Posts/AdminPosts.vue"),
    meta: { permission: { module: "Posts", action: "read" } },
  },
  {
    path: "/admin/posts/view/:id",
    name: "AdminViewPost",
    component: () => import("../views/admin/Posts/AdminViewPost.vue"),
    meta: { permission: { module: "Posts", action: "read" } },
  },
  {
    path: "/admin/events",
    name: "AdminEvents",
    component: () => import("../views/admin/Events/AdminEvents.vue"),
    meta: { permission: { module: "Events", action: "read" } },
  },
  {
    path: "/admin/permissions",
    name: "AdminPermissions",
    component: () => import("../views/admin/Permissions/AdminPermissions.vue"),
    meta: { sadminOnly: true },
  },
  {
    path: "/admin/reports",
    name: "AdminReports",
    component: () => import("../views/admin/Reports/AdminReports.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/subscriptions",
    name: "SubscriptionsReport",
    component: () => import("../views/admin/Reports/SubscriptionsReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/area",
    name: "AreaReport",
    component: () => import("../views/admin/Reports/AreaReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/tax",
    name: "TaxReport",
    component: () => import("../views/admin/Reports/TaxReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/expenses",
    name: "ExpenseReport",
    component: () => import("../views/admin/Reports/ExpenseReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/revenue",
    name: "RevenueReport",
    component: () => import("../views/admin/Reports/RevenueReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/client-rating",
    name: "ClientRatingReport",
    component: () => import("../views/admin/Reports/ClientRatingReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/financial",
    name: "FinancialReport",
    component: () => import("../views/admin/Reports/FinancialReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/reports/all-clients",
    name: "AllClientsReport",
    component: () => import("../views/admin/Reports/AllClientsReport.vue"),
    meta: { permission: { module: "Reports", action: "read" } },
  },
  {
    path: "/admin/configurations/info",
    name: "AdminHouse",
    component: () => import("../views/admin/Configurations/AdminHouse.vue"),
    meta: { permission: { module: "Configurations", action: "read" } },
  },
  {
    path: "/admin/expenses/categories",
    name: "AdminExpenseCategories",
    component: () => import("../views/admin/Expenses/AdminExpenseCategories.vue"),
    meta: { permission: { module: "Expense Categories", action: "read" } },
  },
  {
    path: "/admin/configurations/payment-types",
    name: "AdminPaymentTypes",
    component: () => import("../views/admin/Settings/AdminPaymentTypes.vue"),
    meta: { permission: { module: "Payment Types", action: "read" } },
  },
  {
    path: "/admin/expenses/all",
    name: "AdminExpenses",
    component: () => import("../views/admin/Expenses/AdminExpenses.vue"),
    meta: { permission: { module: "Expenses", action: "read" } },
  },
  {
    path: "/admin/parking/clients",
    name: "AdminParkingClients",
    component: () => import("../views/admin/Parking/AdminParkingClients.vue"),
    meta: { permission: { module: "Parking", action: "read" } },
  },
  {
    path: "/admin/parking/vehicles",
    name: "AdminParking",
    component: () => import("../views/admin/Parking/AdminParking.vue"),
    meta: { permission: { module: "Parking", action: "read" } },
  },
  {
    path: "/admin/parking/invoices",
    name: "AdminParkingInvoices",
    component: () => import("../views/admin/Parking/AdminParkingInvoices.vue"),
    meta: { permission: { module: "Parking Invoices", action: "read" } },
  },
];
export default SAdminRoutes;
